import axios from "axios";
import Env from "../common/Env";
import { GeneralError } from "../common/GeneralError";

let REQUEST_HOST = null;
if (Env.isProduction()) {
  REQUEST_HOST = "uploader.blip.kr";
} else {
  REQUEST_HOST = "uploader-dev.blip.kr";
}

export const UploadCategory = Object.freeze({
  PROFILE: 1,
  COLLECTION: 2,
  TOPIC: 3,
  ARTISTBOARD: 4,
  DASHBOARD: 5,
  BANNER: 6,
  TEST: 99,
});

export class BlipFileUploader {
  // uploadRequestParams definition
  // - category: number
  // - subCategory?: number
  // - mimeType: string
  // - fileName: string
  // - width: number
  // - height: number
  // - fileSize: number
  async requestUploadUrl(uploadRequestParams) {
    const url = `https://${REQUEST_HOST}/uploadRequest`;
    const response = await axios.post(
      url,
      { ...uploadRequestParams, method: "post" },
      { headers: { "Content-Type": "application/json" }, withCredentials: false, crossDomain: false }
    );

    // TODO: uploader API 의 수정이 필요함.
    if (response.error) {
      throw new GeneralError("Presigned URL 요청 중 오류가 발생하였습니다.");
    }

    return response.data.data;
  }

  async markFileAsUploaded(fileId) {
    const url = `https://${REQUEST_HOST}/files/${fileId}`;
    const response = await axios.patch(url, { state: 1 }, { headers: { "Content-Type": "application/json" }, withCredentials: false, crossDomain: false });

    if (response.error) {
      throw new GeneralError("업로드 된 파일의 상태를 변경하던 중 오류가 발생하였습니다.");
    }
  }
}
